import { createContext } from 'react';
/**
 * Instance of the Journey Context component for providing to children and for children to consume.
 */
export const JourneyContextInstance = createContext({});
